import React, { useState, useContext } from 'react';
import {Text, LegacyStack, Link, Modal} from '@shopify/polaris';
import { OfficeHoursContext } from '../../contexts/OfficeHours'
import { SubscriptionsContext } from '../../contexts/Subscriptions'
import { ProductsContext } from '../../contexts/Products'
import { SellingPlansContext } from '../../contexts/SellingPlans'
import { SubscriptionCodesContext } from '../../contexts/SubscriptionCodes'
import { useReducerModal } from '@thinkwell/react.common'
import Productable from '../../concerns/Productable'

export default function AddOfficeHour(props) {
  const [state, onActive] = useReducerModal(props, props.active);
  const subscriptions = useContext(SubscriptionsContext)
  const [officeHours] = useContext(OfficeHoursContext)
  const [products] = useContext(ProductsContext)
  const sellingPlans = useContext(SellingPlansContext)
  const subscriptionCodes = useContext(SubscriptionCodesContext)

  const subscription = subscriptions.find((s) => s.id == props.subscription_id)

  const officeHour = officeHours.find((officeHour) => officeHour.relatesTo(subscription.sku))

  const sellingPlansForVariant = sellingPlans.filter((sellingPlan) => sellingPlan.variantId == officeHour.variantId)
  const imageSrc = Productable.imageSrc(products, officeHour)

  const createOfficeHourRow = (index, price, sellingPlanId) => {
    const priceStr = `$${price}`
    return (<tr key={sellingPlanId || index}>
      { index == 0 ? <td className="thumbnail-large"><img src={imageSrc}/></td> : <td/> }
      <td>
        { index == 0 ? <p dangerouslySetInnerHTML={{__html: officeHour.bodyHtml}}></p> : null }
        <span className="Polaris-TextStyle--variationStrong" data-text={priceStr}>{priceStr}</span>
        <form id="registration-form" action="/cart/add" method="post">
          <input type="hidden" name="id" value={officeHour.variantId} />
          <input type="hidden" name="properties[_assign_to_email]" value={subscription.assignedToEmail} />
          <input type="hidden" name="properties[Course]" value={subscription.title(products, subscriptionCodes)} />
          { sellingPlanId ?
            <div>
              <input type="hidden" name="properties[_subscription]" value={`${sellingPlanId}-${Date.now()}`} />
              <input type="hidden" name="selling_plan" value={sellingPlanId} /> : null
            </div>
            : null
          }
          <input type="submit" className="button" value="Buy Live Tutoring/Office Hours" />
        </form>
      </td>
    </tr>)
  };
  
  return (
    officeHour ?
      (<div className={state.active ? 'open' : 'closed'}>
        <Link onClick={() => onActive(true)}>Buy Live Tutoring/Office Hours</Link>
        <Modal
          open={state.active}
          onClose={() => onActive(false)}
          title={officeHour.title}
        >
          <Modal.Section>
            <table><tbody>
              {
                sellingPlansForVariant.length > 0 ? 
                sellingPlansForVariant.map((sellingPlan, index) => {
                  const price = (sellingPlan && sellingPlan.price) || officeHour.price;
                  return createOfficeHourRow(index, price, sellingPlan.id);
                }) : 
                createOfficeHourRow(0, officeHour.price)
              }
            </tbody></table>
          </Modal.Section>
        </Modal>
      </div>) : null
  );
}
